import MenuButton from 'apollo-react/components/MenuButton';
import React from 'react';

export const QueueTableActionComponent = ({ selectedRows = [], menuAction, handleClick }) => {
  const menuActionName = menuAction
    ? menuAction.split(',').map((actionName) => {
        return { text: actionName, onClick: () => handleClick(actionName) };
      })
    : [];

  const menuActionEnableOrDisable = selectedRows.length <= 0 ? 'disabled' : '';
  return (
    menuActionName.length > 0 && (
      <MenuButton
        buttonText="Actions"
        menuItems={menuActionName}
        disabled={menuActionEnableOrDisable}
      />
    )
  );
};
